import { render, staticRenderFns } from "./ReminderSelectTemplates.vue?vue&type=template&id=e1113270"
import script from "./ReminderSelectTemplates.vue?vue&type=script&lang=ts"
export * from "./ReminderSelectTemplates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1113270')) {
      api.createRecord('e1113270', component.options)
    } else {
      api.reload('e1113270', component.options)
    }
    module.hot.accept("./ReminderSelectTemplates.vue?vue&type=template&id=e1113270", function () {
      api.rerender('e1113270', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/ReminderSelectTemplates.vue"
export default component.exports